'use client';

import { useMemo } from 'react';
import { useAuthStore } from './use-auth';

/**
 * Compares the user's browser-detected timezone with their stored profile
 * timezone. Returns mismatch info so UI can prompt the user to update.
 */
export function useTimezoneCheck() {
  const user = useAuthStore((s) => s.user);

  return useMemo(() => {
    if (!user?.timezone) {
      return { mismatch: false, browserTz: '', profileTz: '' };
    }

    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const profileTz = user.timezone;

    return {
      mismatch: browserTz !== profileTz,
      browserTz,
      profileTz,
    };
  }, [user?.timezone]);
}
